export default function withlocalsOrganizationSchema() {
  return {
    '@type': 'Organization',
    url: URL_HOST,
    name: 'Withlocals',
    legalName: 'Withlocals B.V.',
    foundingDate: '2014-01-01',
    vatID: 'NL852909470B01',
    duns: '491055142',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'the Netherlands',
      addressLocality: 'Eindhoven',
      postalCode: '5611 EG',
      streetAddress: 'Ten Hagestraat 4',
      email: 'info@withlocals.com',
    },
    sameAs: [
      'https://www.facebook.com/WithLocals',
      'https://instagram.com/WithLocals',
      'https://www.youtube.com/withlocals',
    ],
    contactPoint: [
      {
        telephone: '+31202440076',
        contactType: 'Customer Service',
      },
    ],
  };
}
